/**
 * Head portal session checks (enterprise / nyafaz / naturals portal APIs).
 * Never treat HTTP 200 alone as logged in — some /me routes return 200 with authenticated: false.
 */

export function isPortalHeadMeAuthenticated(data, res) {
  if (!data || typeof data !== "object") return false;
  if (data.authenticated === false) return false;
  if (data.authenticated === true && data.userId) return true;
  if (res?.ok && data.userId) return true;
  return false;
}

export async function readPortalHeadMe(meUrl, fetchOptions = {}) {
  const res = await fetch(meUrl, {
    credentials: "include",
    headers: { Accept: "application/json", ...(fetchOptions.headers || {}) },
    ...fetchOptions,
  });
  const contentType = (res.headers.get("content-type") || "").toLowerCase();
  let data = {};
  if (contentType.includes("application/json")) {
    try {
      data = await res.json();
    } catch {
      data = {};
    }
  }
  const authenticated = isPortalHeadMeAuthenticated(data, res);
  return { res, data, authenticated };
}

export async function verifyPortalHeadSession(meUrl, { onStaleStorage } = {}) {
  try {
    const { res, data, authenticated } = await readPortalHeadMe(meUrl);
    const contentType = (res.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      if (typeof onStaleStorage === "function") onStaleStorage();
      return false;
    }
    if (!authenticated) {
      if (typeof onStaleStorage === "function") onStaleStorage();
      return false;
    }
    return { authenticated: true, data };
  } catch {
    if (typeof onStaleStorage === "function") onStaleStorage();
    return false;
  }
}
